import React from 'react'

import { useFeatureGate } from '~hooks/access/useFeatureGate'
import PageNotFoundScreen from '~pages/PageNotFoundScreen'

const RequireFeatureFlag: React.FC<{ flag: string; children: React.ReactElement }> = ({
  flag,
  children,
}) => {
  const { enabled, loading } = useFeatureGate(flag)

  if (loading) return null
  if (!enabled) return <PageNotFoundScreen permissionsError={false} />

  return children
}

export default RequireFeatureFlag
